
import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import coursesImg from "../images/courses.jpg"

export default class CoursesIvano extends Component {
    render() {

    return (

      <div className="main-wrapper">
        <div className="heaerBgImg">
          <Header></Header>
            <div className="header-head">
              <div className='container'><h4>Courses</h4></div>
            </div>
        </div>
        <div className="main-content px-0 career-wrapper"> 
          <div className='container'>
            <div className="career-panel"> 
              <div className="career-head">
                <h4>Courses</h4>
                <p>Live Online Masterclass.</p>
              </div>
              <div className="career-body">
                <div className="career-box">
                  <a href="#" className="career-box-a">
                    <img alt="" className="career-img" src={coursesImg} />
                    <p className="career-box-text">Cybersecurity</p>
                  </a>
                </div>
                <div className="career-box">
                  <a href="#" className="career-box-a">
                    <img alt="" className="career-img" src={coursesImg} />
                    <p className="career-box-text">Cybersecurity</p>
                  </a>
                </div>
                <div className="career-box">
                  <a href="#" className="career-box-a">
                    <img alt="" className="career-img" src={coursesImg} />
                    <p className="career-box-text">Cybersecurity</p>
                  </a>
                </div>
                <div className="career-box">
                  <a href="#" className="career-box-a">
                    <img alt="" className="career-img" src={coursesImg} />
                    <p className="career-box-text">Cybersecurity</p>
                  </a>
                </div>
                <div className="career-box">
                  <a href="#" className="career-box-a">
                    <img alt="" className="career-img" src={coursesImg} />
                    <p className="career-box-text">Cybersecurity</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <Footer></Footer>
      </div>
      )
    }
}


// WEBPACK FOOTER //
// ./src/ivano/courses.jsx